import { render, staticRenderFns } from "./MobileCamera.vue?vue&type=template&id=2a7047ae&scoped=true"
import script from "./MobileCamera.vue?vue&type=script&lang=js"
export * from "./MobileCamera.vue?vue&type=script&lang=js"
import style0 from "./MobileCamera.vue?vue&type=style&index=0&id=2a7047ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7047ae",
  null
  
)

export default component.exports